// extracted by mini-css-extract-plugin
module.exports = {"quantitySelector":"MhRYY","quantitySelector-container":"yu6u0","quantity-content":"-7Ymu","quantity-btn":"TLko+"};